import React from 'react';
import { Link } from 'react-router-dom';

const Pricing = () => {
  return (
    <div className="d-flex flex-column min-vh-100" style={{ background: '#1f2028' }}>
      {/* Navigation Bar */}
      <div style={{ position: 'sticky', top: 0, zIndex: 1000, backgroundColor: '#1f2028', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="container-fluid px-3">
          <div className="d-flex align-items-center justify-content-between py-2" style={{ height: '48px' }}>
            {/* Logo/Brand */}
            <div>
              <Link to="/" className="text-decoration-none">
                <h5 className="text-light mb-0 fw-bold" style={{ fontSize: '1.1rem' }}>RE Calc</h5>
              </Link>
            </div>
            
            {/* Navigation Links */}
            <div>
              <Link to="/features" className="btn btn-link text-light text-decoration-none">Features</Link>
              <Link to="/faqs" className="btn btn-link text-light text-decoration-none">FAQs</Link>
              <Link to="/contact" className="btn btn-link text-light text-decoration-none">Get in Touch</Link>
              <Link to="/pricing" className="btn btn-link text-light text-decoration-none">Pricing</Link>
              <Link to="/signup" className="btn btn-primary btn-sm ms-3">Ready to Start?</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container py-5">
        <div className="text-center mb-5">
          <h1 className="text-white mb-3">Simple, Transparent Pricing</h1>
          <p className="text-light lead">Choose the plan that fits your investment strategy</p>
        </div>
        
        <div className="row justify-content-center g-4">
          {/* Free Plan */}
          <div className="col-lg-4 col-md-6">
            <div className="card bg-dark border-secondary h-100">
              <div className="card-body p-4">
                <h5 className="text-white mb-0">Free</h5>
                <div className="d-flex align-items-baseline mt-2">
                  <h2 className="text-white mb-0">$0</h2>
                  <span className="text-muted ms-1">/month</span>
                </div>
                <p className="text-muted mt-2">Perfect for beginners</p>
                <hr className="border-secondary my-4" />
                <ul className="list-unstyled">
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Up to 3 property analyses</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Basic ROI calculations</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Standard expense templates</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-x-circle-fill text-muted me-2"></i>
                    <span className="text-muted">Scenario comparison</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-x-circle-fill text-muted me-2"></i>
                    <span className="text-muted">Portfolio management</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-x-circle-fill text-muted me-2"></i>
                    <span className="text-muted">Custom settings</span>
                  </li>
                </ul>
                <Link to="/signup" className="btn btn-outline-light w-100 mt-4">Get Started</Link>
              </div>
            </div>
          </div>
          
          {/* Pro Plan */}
          <div className="col-lg-4 col-md-6">
            <div className="card bg-dark border-primary h-100" style={{ borderWidth: '2px' }}>
              <div className="card-body p-4">
                <div className="ribbon bg-primary text-white px-3 py-1 position-absolute" style={{ top: '1rem', right: '-0.5rem' }}>Popular</div>
                <h5 className="text-white mb-0">Pro</h5>
                <div className="d-flex align-items-baseline mt-2">
                  <h2 className="text-white mb-0">$19</h2>
                  <span className="text-muted ms-1">/month</span>
                </div>
                <p className="text-muted mt-2">For active investors</p>
                <hr className="border-secondary my-4" />
                <ul className="list-unstyled">
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Unlimited property analyses</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Advanced ROI calculations</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Custom expense templates</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Scenario comparison (up to 3)</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Basic portfolio management</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-x-circle-fill text-muted me-2"></i>
                    <span className="text-muted">Advanced custom settings</span>
                  </li>
                </ul>
                <Link to="/signup" className="btn btn-primary w-100 mt-4">Get Started</Link>
              </div>
            </div>
          </div>
          
          {/* Enterprise Plan */}
          <div className="col-lg-4 col-md-6">
            <div className="card bg-dark border-secondary h-100">
              <div className="card-body p-4">
                <h5 className="text-white mb-0">Enterprise</h5>
                <div className="d-flex align-items-baseline mt-2">
                  <h2 className="text-white mb-0">$49</h2>
                  <span className="text-muted ms-1">/month</span>
                </div>
                <p className="text-muted mt-2">For professional investors</p>
                <hr className="border-secondary my-4" />
                <ul className="list-unstyled">
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Everything in Pro plan</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Unlimited scenario comparison</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Advanced portfolio analytics</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Advanced custom settings</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Priority support</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    <span className="text-light">Data export capabilities</span>
                  </li>
                </ul>
                <Link to="/signup" className="btn btn-outline-light w-100 mt-4">Get Started</Link>
              </div>
            </div>
          </div>
        </div>
        
        <div className="text-center mt-5">
          <h3 className="text-white mb-4">Need a custom solution?</h3>
          <p className="text-light mb-4">Contact us for custom enterprise solutions tailored to your specific needs.</p>
          <Link to="/contact" className="btn btn-outline-light">Contact Us</Link>
        </div>
        
        <div className="card bg-dark border-secondary mt-5">
          <div className="card-body p-4">
            <h3 className="text-white mb-4">Frequently Asked Questions</h3>
            
            <div className="row">
              <div className="col-md-6 mb-4">
                <h5 className="text-white">Can I upgrade or downgrade my plan?</h5>
                <p className="text-light">Yes, you can upgrade or downgrade your plan at any time. Changes will take effect at the start of your next billing cycle.</p>
              </div>
              
              <div className="col-md-6 mb-4">
                <h5 className="text-white">Do you offer annual billing?</h5>
                <p className="text-light">Yes, we offer annual billing with a 20% discount compared to monthly billing.</p>
              </div>
              
              <div className="col-md-6 mb-4">
                <h5 className="text-white">Is there a free trial?</h5>
                <p className="text-light">Yes, all paid plans come with a 14-day free trial. No credit card required to start.</p>
              </div>
              
              <div className="col-md-6 mb-4">
                <h5 className="text-white">What payment methods do you accept?</h5>
                <p className="text-light">We accept all major credit cards, PayPal, and bank transfers for annual plans.</p>
              </div>
            </div>
            
            <div className="text-center mt-3">
              <Link to="/faqs" className="btn btn-link text-primary">View all FAQs</Link>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="py-4 mt-auto" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <p className="text-muted mb-0 small">© 2025 RE Calc. All rights reserved.</p>
            <div>
              <Link to="/login" className="text-muted me-3 small">Login</Link>
              <Link to="/signup" className="text-muted small">Sign Up</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Pricing;
